import Vue from 'vue';
import Router from 'vue-router';
import CSSManager from '../services/CSSManager';
import MainSite from '../views/main-site/index'
// import Schedule from '../components/Schedule'
import Schedule from '../views/schedule'
import QuemSomos from '../views/main-site/quem-somos'
import Plano from '../views/main-site/planos'
import Contato from '../views/main-site/contato'
import Login from '../views/main-site/login'
import Barbearia from '../views/landpages/barbearia'
import Manicure from '../views/landpages/manicure'
import Beleza from '../views/landpages/beleza'
import Ajuda from '../views/help/Ajuda'

Vue.use(Router);

const router = new Router({

    hashbang: false,
    history: true,
    mode: 'history',
    routes:[
        {
            path:'/',
            name:'',
            component: MainSite,
            meta: { layout: 'MainSiteLayout' }
        },
        {
            path:'/home',
            name:'inicio',
            component: MainSite,
            meta: { layout: 'MainSiteLayout' }
        },
        {
            path:'/login',
            name:'login',
            component: Login,
            meta: { layout: 'MainSiteLayout' }
        },
        {
            path:'/quemsomos',
            name:'sobre',
            component: QuemSomos,
            meta: {
                title: 'Home Page - Example App',
                layout: 'MainSiteLayout'
            }
        },
        {
            path:'/planos',
            name:'planos',
            component: Plano,
            meta: { layout: 'MainSiteLayout' }
        },
        {
            path:'/contato',
            name:'contato',
            component: Contato,
            meta: { layout: 'MainSiteLayout' }
        },
        {
            path:'/barbearia',
            name:'barbearia',
            component: Barbearia,
            meta: { layout: 'LandpageLayout' }
        },
        {
            path:'/beleza',
            name:'beleza',
            component: Beleza,
            meta: { layout: 'LandpageLayout' }
        },
        {
            path:'/manicure',
            name:'manicure',
            component: Manicure,
            meta: { layout: 'LandpageLayout' }
        },
        {
            path:'/ajuda',
            name:'ajuda',
            component: Ajuda,
            meta: { layout: 'HelpLayout' }
        },
        {
            path:'/:company',
            name:'',
            component: Schedule,
            meta: { layout: 'ScheduleLayout' }
        },
    ]
});

/**
 * Global router hook to manage CSS injection/removal
 * This ensures CSS is injected BEFORE the component renders
 */
router.beforeEach((to, from, next) => {
    const layoutName = to.meta.layout || 'MainSiteLayout';
    // Wait for CSS to be injected/loaded before navigating to avoid FOUC
    CSSManager.injectLayoutCss(layoutName).then(() => next()).catch(() => next());
});

router.afterEach((to, from) => {
  const newLayout = to.meta.layout;
  const oldLayout = from.meta.layout;
  
  // Only remove CSS if we're switching layouts
  if (oldLayout && oldLayout !== newLayout) {
        CSSManager.removeLayoutCss(oldLayout);
  }
});

export default router;